import React, { FC, PropsWithChildren } from "react";
import "./CarouselItem.scss";

export interface CarouselItemProps {
    readonly className?: string;
}

export const CarouselItem: FC<PropsWithChildren<CarouselItemProps>> = props => {
    return (
        <div className={`xapp-search-carousel-item ${props.className || ""}`}>
            {props.children}
        </div>
    );
};

